import { Field, reduxForm } from 'redux-form/immutable';
import { TextField, Select, DatePicker } from 'redux-form-material-ui';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { createTextMask } from 'redux-form-input-masks';

import FormSelect from './form_select';
import theme from '../theme';

const FieldTheme = createMuiTheme({
  palette: {
    primary: {
      light: theme.color.primary,
      main: theme.color.primary,
      dark: theme.color.primary,
    },
  },
});

export {
  Field, reduxForm, TextField, Select, MenuItem, InputLabel, FormControl, FormSelect, FieldTheme, MuiThemeProvider, DatePicker, createTextMask,
};



// WEBPACK FOOTER //
// ./src/common/form/form.js